import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  max-width: ${layout.maxWidth};
  margin: 0 auto;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    gap: ${space['space-1200']};
    padding: ${space['space-800']} ${layout.horizontalPadding};
  }
`;

export const LeftColumn = styled.div`
  text-align: center;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 40%;
    flex-shrink: 0;
    position: sticky;
    top: ${space['space-800']};
    align-self: flex-start;
    text-align: left;
  }
`;

export const CategoryImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: 4 / 3;
    border-radius: ${size.radius['radius-md']};
  }
`;

export const CategoryImagePlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  background: ${semantic.bg.surfaceSubtle};

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: 4 / 3;
    border-radius: ${size.radius['radius-md']};
  }
`;

export const CategoryHeading = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: ${space['space-400']} 0 0;
  line-height: ${primitives.typography.lineHeight.tight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
    margin: ${space['space-600']} 0 0;
  }
`;

export const DescriptionWrapper = styled.div`
  margin: ${space['space-300']} ${space['space-400']} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin: ${space['space-300']} 0 0;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  flex: 1;
  min-width: 0;
  padding: 0 ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0;
  }
`;
